/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { menu } from "../../../../../menu";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setMenu } from "../../../../../app/modules/Auth/redux/authReducer";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };
  const { menu, menuType } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const {
    user: { accessToken, refreshToken, data },
  } = useSelector((state) => state.auth);

  const getMenu = async (menuType) => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/user-role-feature/userRoleModuleWithFeature/${menuType}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      dispatch(setMenu(data.data));
    }
  };

  useEffect(() => {
    getMenu(menuType);
  }, [menuType]);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {menu.map((menu, i) => (
          <li
            key={i}
            className={`menu-item ${
              menu.submenu ? "menu-item-submenu" : ""
            } ${getMenuItemActive(`/${menu.url}`, true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to={`/${menu.url}`}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl(menu.icon)} />
              </span>
              <span className="menu-text">{menu.menu}</span>
              {menu.submenu ? <i className="menu-arrow" /> : ""}
            </NavLink>

            {menu.submenu ? (
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">{menu.menu}</span>
                    </span>
                  </li>
                  {menu.submenu.map((submenu, i) => (
                    <li
                      key={i}
                      className={`menu-item  ${getMenuItemActive(
                        `/${submenu.frontend_menu}`
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link  menu-toggle"
                        to={`/${submenu.frontend_menu}`}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {submenu.feature_name}
                        </span>
                        {submenu.thirdmenu ? <i className="menu-arrow" /> : ""}
                      </NavLink>
                      {submenu.thirdmenu ? (
                        <>
                          {submenu.feature_name === "Wastage" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item  ${getMenuItemActive(
                                    "/admin-setting/wastage/master"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/wastage/master"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Wastage Master
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/wastage/price-setting"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/wastage/price-setting"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Price Setting
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Zone" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item  ${getMenuItemActive(
                                    "/admin-setting/zone/zone-list"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/zone/zone-list"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Zone Master
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/zone/zone-wise-upazilla-list"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/zone/zone-wise-upazilla-list"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Zone Wise Upazilla
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Delivery" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/delivery-charge"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/delivery-charge"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Delivery Charge
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/delivery-man"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/delivery-man"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Delivery Man
                                    </span>
                                  </NavLink>
                                </li>

                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/delivery-settings"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/delivery-settings"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Delivery Settings
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Packaging" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/carton"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/carton"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">Carton</span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/packet"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/packet"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">Packet</span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Fabrication" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item  ${getMenuItemActive(
                                    "/admin-setting/fabrication/fabrication-attribute"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/fabrication/fabrication-attribute"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Fabrication Attribute
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/fabrication/fabrication-model"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/fabrication/fabrication-model"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Fabrication Model
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}

                                {/*begin::3 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/admin-setting/fabrication/model-attribute-fabrication"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/admin-setting/fabrication/model-attribute-fabrication"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Fabrication Model Attribute
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::3 Level*/}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Delivery process" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                {/*begin::2 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/process/create"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/process/create"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Create Delivery
                                    </span>
                                  </NavLink>
                                </li>
                                {/*end::2 Level*/}

                                {/*begin::2 Level*/}
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/process/delivery-batch-lis"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  {/* <NavLink
                                    className="menu-link"
                                    to="/delivery-process/release-delivery"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Release Delivery
                                    </span>
                                  </NavLink> */}
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/process/delivery-batch-list"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Delivery Batch List
                                    </span>
                                  </NavLink>
                                </li>
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}

                          {submenu.feature_name === "Shipment" ? (
                            <div className="menu-submenu ">
                              <i className="menu-arrow" />
                              <ul className="menu-subnav">
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/shipment/distribution"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/shipment/distribution"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Create Shipment
                                    </span>
                                  </NavLink>
                                </li>

                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/shipment/received-by-secondary"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/shipment/received-by-secondary"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Received by secondary
                                    </span>
                                  </NavLink>
                                </li>

                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/shipment/release-delivery"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/shipment/release-delivery"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Release Delivery
                                    </span>
                                  </NavLink>
                                </li>

                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/delivery-process/shipment/shipped-batch-list"
                                  )}`}
                                  aria-haspopup="true"
                                >
                                  <NavLink
                                    className="menu-link"
                                    to="/delivery-process/shipment/shipped-batch-list"
                                  >
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">
                                      Shipped Batch List
                                    </span>
                                  </NavLink>
                                </li>
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
          </li>
        ))}

        {data.userRoleId === 1 || data.userRoleId === 19 ? (
          <>
            {/* reciepe */}

            {/* {submenu.feature_name === "Wastage" ? <div></div> : ""} */}
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/recipes",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/recipes">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Group.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Recipes</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Recipe</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/recipes/recipe-add"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/recipes/recipe-add">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Add Recipe</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/recipes/recipe-list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/recipes/recipe-list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Recipe List</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}
                </ul>
              </div>
            </li>

            {/* products */}

            {/* promotions */}

            {/* <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/promotions",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/promotions">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Group.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Promotions</span>
                <i className="menu-arrow" />
              </NavLink>

              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Promotions</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/coupons-list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/promotions/coupons-list"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Coupons List</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive("/promotion")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/promotions/promotion">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Promotion</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/promotion-list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/promotions/promotion-list"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Promotion List</span>
                    </NavLink>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/discount-list-productwise"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/promotions/discount-list-productwise"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        Discount List productwise
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
          </>
        ) : (
          ""
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
